export default __webpack_public_path__ + "static/media/scallop_shape.182b49f8.jpeg";